import React from "react";

export function LoginBrandPanel({ ip }) {
  const features = [
    { icon: "t-icon-home3", label: "Ev tasarrufu", desc: "Planınızı tek ekrandan yönetin" },
    { icon: "t-icon-directions_car", label: "Araç tasarrufu", desc: "Ödemelerinizi kolayca takip edin" },
    { icon: "t-icon-office", label: "İş yeri tasarrufu", desc: "Hedefinize güvenle ilerleyin" },
  ];

  return (
    <aside className="t-loginPage-aside" aria-hidden="false">
      <div className="t-loginPage-asideBg" aria-hidden="true" />
      <div className="t-loginPage-asideInner">
        <div className="t-loginPage-asideTop">
          <img
            src="/assets/img/svg/logo_internetSube.svg"
            alt="Eminevim İnternet Şube"
            className="t-loginPage-asideLogo"
          />
        </div>

        <div className="t-loginPage-asideBody">
          <h2 className="t-loginPage-asideTitle">
            <span className="t-loginPage-asideTitleFirst">Modelinizi Seçin,</span>{" "}
            <span className="t-loginPage-asideTitleAccent">Kendi aracınızın koltuğuna geçin.</span>
          </h2>
          <p className="t-loginPage-asideLead">
            Tasarruf planınızı yönetin, ödemelerinizi izleyin ve hedefinize emin adımlarla ilerleyin.
          </p>

          <ul className="t-loginPage-asideFeatures">
            {features.map((item) => (
              <li key={item.label} className="t-loginPage-asideFeature">
                <span className="t-loginPage-asideFeatureIcon">
                  <i className={item.icon} aria-hidden="true" />
                </span>
                <span className="t-loginPage-asideFeatureText">
                  <strong>{item.label}</strong>
                  <span>{item.desc}</span>
                </span>
              </li>
            ))}
          </ul>
        </div>

        <footer className="t-loginPage-asideFooter">
          {ip ? <span>{ip}</span> : null}
          <span>© EMİNEVİM</span>
        </footer>
      </div>
    </aside>
  );
}

export default LoginBrandPanel;
